import BodyColumnData from "@/components/body/BodyColumnData";
import BodyContainer from "@/components/body/BodyContainer";
import BodyValues from "@/components/body/BodyValues";
import Labs from "@/components/body/Labs";
import PatientDetailBody from "@/components/body/PatientDetailBody";
import Popups from "@/components/popups/";
import Alerts from "@/components/shared/Alerts";
import BodySharedMinData from "@/mixins/BodySharedMinData";
import GraphRanges from "@/mixins/GraphRanges";
import Layout from "@/mixins/Layout";
import SwiperSettings from "@/mixins/SwiperSettings";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { userNamespace } from "@/store/modules/user";
import { Component, Mixins } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({
  components: {
    PatientDetailBody,
    Alerts,
    BodyContainer,
    BodyValues,
    Labs,
    BodyColumnData,
    ...Popups
  }
})
export default class MobileMin extends Mixins(
  BodySharedMinData,
  Layout,
  SwiperSettings,
  GraphRanges
) {
  minLegendChartHeight = "180px";
  minStackedChartHeight = "200px";

  @Getter("current", patientNamespace)
  patient!: Patient;

  @Getter("graph", patientNamespace)
  graph!: any;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("showLegendMobile", navigationNamespace)
  showLegendMobile!: boolean;

  @Getter("hasWaves", patientNamespace)
  hasWaves!: boolean;

  @Getter("showStaff", patientNamespace)
  showStaff!: boolean;

  @Getter("showGreenGrayOnly", userNamespace)
  showGreenGrayOnly!: any;

  popupOverride() {
    this.setMobilePage(2);
  }

  get legendItems() {
    if (this.patient && this.showGreenGrayOnly) {
      return this.config.body.patientLegend;
    } else {
      return this.config.body.legend;
    }
  }
}
